import { render, staticRenderFns } from "./fclForm.vue?vue&type=template&id=8c124d50&"
import script from "./fclForm.vue?vue&type=script&lang=js&"
export * from "./fclForm.vue?vue&type=script&lang=js&"
import style0 from "./fclForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c124d50')) {
      api.createRecord('8c124d50', component.options)
    } else {
      api.reload('8c124d50', component.options)
    }
    module.hot.accept("./fclForm.vue?vue&type=template&id=8c124d50&", function () {
      api.rerender('8c124d50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceFCL/components/PriceFCL/fclForm.vue"
export default component.exports